module.exports = __webpack_public_path__ + "img/traffic-light-green.9427b0fc.svg";